import Image from '@next/image';

import { ConferencePartner } from 'types/models/Conference';

import classes from './ConferencePartners.module.scss';

type Props = {
  partners: ConferencePartner[];
};

const ConferencePartners = ({ partners }: Props) => (
  <div className={classes.logos}>
    {partners.map(({ id, image, name }) => (
      <div key={id} className={classes.logo}>
        <Image
          objectFit="contain"
          title={name}
          alt={name}
          resolveConfig={{
            preset: 'customer_logo',
            productName: 'customer_logo',
            extension: image.extension,
            name: image.basename,
            description: name,
          }}
        />
      </div>
    ))}
  </div>
);

export default ConferencePartners;
